import {Component, OnInit, Injector, OnDestroy, Input, Output, EventEmitter, ViewChildren, QueryList} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl} from '@angular/forms';

import {Criterio, Meta, NivelCriterio, Version} from '../../../_models/meta';
import {GLMLanguageService} from '../../../_services/glm-language.service';
import {GlmModalService} from '../../../_components/glm-modal/glm-modal.service';
import {EstudioService} from '../estudio.service';
import {CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';
import {MatSnackBar } from '@angular/material/snack-bar';
import {UnidadEtapasService} from '../unidad-etapas/_services/unidad-etapas.service';
import {ComentariosService} from '../../../_components/glm-comentarios/comentarios.service';
import {Comentario} from '../../../_models/comentario';
import {environment} from '../../../../environments/environment';
import {AuthenticationService} from '../../../_services';
import { GlobalService } from 'src/app/_services/global.service';
import { find } from 'rxjs/operators';
import { CkeditorImageDeleteDirective } from 'src/app/_directives/ckeditor-image-delete/ckeditor-image-delete.directive';
const API_URL = environment.apiUrl;

/// Reestructuración: pedido de datos de la versión al cambiar de versión?
/// POST al crear una nueva versión con el id de la nueva versión en -1
/// UPDATE al modificar una versión vieja
/// Parametro isEditable de la versión de la meta dependiendo de si la versión ya fue evaluada.
/// Pedido aparte de las versiones de la meta.
/// Cambiar la meta en unidad al guardar una nueva versión.

@Component({
  selector: 'meta-form',
  standalone: false,
  templateUrl: 'meta-form.component.html',
  styleUrls: ['meta-form-component.scss']
})
export class MetaFormComponent implements OnInit, OnDestroy {

  metaForm: UntypedFormGroup;

  displayLang: string;

  @Input()
  _meta: Meta;
  @Input()
  tiposMeta: any[];
  @Input()
  cursosOpt: any[];
  @Input()
  areas: any[];
  @Input()
  profesores: any[];
  @Input()
  ambitos: any[];
  @Input()
  tags: any[];
  @Input()
  contexto: string;
  @Input()
  metaUnidadID: number | string;
  @Input()
  unidadId: number;

  editMainContent = true;
  ckeditorImageEndPoint = `${API_URL}/api/storage/uploadimg`;
  refreshUrl = `${API_URL}/api/jwt/refresh`;
  userToken;
  refreshToken;
  idiomas: string[];

  @Input()
  activeTab = 0;

  comentariosMeta: Comentario[] = [];

  sortableOptions: any;

  @Output()
  actualizar: EventEmitter<any>;

  @Output()
  cerrarDialog: EventEmitter<any>;

  @Output()
  guardandoEvent: EventEmitter<boolean>;

  versionForm: UntypedFormControl;

  versionActual: string;

  @ViewChildren(CkeditorImageDeleteDirective) deleteImageDirectives: QueryList<CkeditorImageDeleteDirective>;

  constructor(private fb: UntypedFormBuilder,
              private injector: Injector,
              private snackBar: MatSnackBar,
              private estudioService: EstudioService,
              private unidadEtapasService: UnidadEtapasService,
              private modalService: GlmModalService,
              private languageService: GLMLanguageService,
              private customAlertService: CustomAlertService,
              private comentariosService: ComentariosService,
              private authService: AuthenticationService,
              private globalService: GlobalService) {
    this.userToken = authService.currentUserValue.token;
    this.refreshToken = authService.currentUserValue.refresh;
    const that = this;
    this.sortableOptions = {
      onSort: (event: any) => {
        that.ordenarCriterios(event);
      },
    };
    this.actualizar = new EventEmitter();
    this.cerrarDialog = new EventEmitter();
    this.guardandoEvent = new EventEmitter();
  }

  ngOnInit() {
    this.globalService.idiomas$.subscribe(res => this.idiomas = res.map(item => item.value));
    if (+this.activeTab === 2) {
      this.comentariosService.getComentariosPorObjeto(this.metaUnidadID, 'unidadmeta').subscribe(res => {
        this.comentariosMeta = this.estudioService.extractData(res);
      });
      this.editMainContent = false;
    }
    const curLang = this.languageService.getCurrLanguage() ? this.languageService.getCurrLanguage().activeLang.nickName : 'es';
    if (this.activeTab === 0) {
      if (this._meta['html' + curLang.toUpperCase()]) {
        this.displayLang = curLang;
      } else {
        this.displayLang = this._meta.htmlEN ?
        'en' : this._meta.htmlFR ? 'fr' : 'es';
      }
      if (this.displayLang === undefined) {
        this.displayLang = curLang;
      }
    } else if (this.activeTab === 1) {
      if (this._meta.criteriosIdiomasVista[curLang] === 1) {
        this.displayLang = curLang;
      } else {
        for (const prop in this._meta.criteriosIdiomasVista) {
          if (Object.prototype.hasOwnProperty.call(this._meta.criteriosIdiomasVista, prop)) {
            if (this._meta.criteriosIdiomasVista[prop] === 1) {
              this.displayLang = prop;
              break;
            }
          }
        }
        if (this.displayLang === undefined) {
          this.displayLang = curLang;
        }
      }
    }
    this.changeIdiomaDisplay(this.displayLang);
    if (this.contexto === 'unidad_etapas') {

    }
    if (this._meta.versiones) {
      const versionActualObj = this._meta.versiones.find(version => version.id === this._meta.versionId);
      if (versionActualObj) {
        this.versionActual = versionActualObj.majorVersion + '.' + versionActualObj.minorVersion;
      } else {
        this.versionActual = 'err';
      }
    } else {
      this.versionActual = this._meta.majorVersion + '.' + this._meta.minorVersion;
    }
    this.versionForm = new UntypedFormControl(this._meta.versionId);
    this.buildForm();
  }

  onChangeTab(index) {
    const curLang = this.languageService.getCurrLanguage() ? this.languageService.getCurrLanguage().activeLang.nickName : 'es';
    if (+index === 0) {
      this.editMainContent = true;
      if (this._meta['html' + curLang.toUpperCase()]) {
        this.displayLang = curLang;
      } else {
        this.displayLang = this._meta.htmlEN ?
        'en' : this._meta.htmlFR ? 'fr' : 'es';
      }
      if (this.displayLang === undefined) {
        this.displayLang = curLang;
      }
      this.changeIdiomaDisplay(this.displayLang);
    } else if (+index === 2) {
      this.comentariosService.getComentariosPorObjeto(this.metaUnidadID, 'unidadmeta').subscribe(res => {
        this.comentariosMeta = this.estudioService.extractData(res);
      });
      this.editMainContent = false;
    } else {
      if (this._meta.criteriosIdiomasVista[curLang] === 1) {
        this.displayLang = curLang;
      } else {
        for (const prop in this._meta.criteriosIdiomasVista) {
          if (Object.prototype.hasOwnProperty.call(this._meta.criteriosIdiomasVista, prop)) {
            if (this._meta.criteriosIdiomasVista[prop] === 1) {
              this.displayLang = prop;
              break;
            }
          }
        }
        if (this.displayLang === undefined) {
          this.displayLang = curLang;
        }
      }
      this.editMainContent = false;
      this.changeIdiomaDisplay(this.displayLang);
    }
  }

  buildForm() {
    const currTipoMeta = +this._meta.id !== 0 ? this._meta.categoriaID : '',
      currCursos = +this._meta.id !== 0 ?
        this._meta.cursos
          .map(curso => {
            return curso.id;
          }) : [],
      currAreas = +this._meta.id !== 0 ?
        this._meta.materias
          .map(materia => {
            return materia.id;
          }) : [],
      currAmbitos = +this._meta.id !== 0 ?
        this._meta.ambitos.map(ambito => {
          return ambito.id;
        }) : [],
      currTags = +this._meta.id !== 0 ?
        this._meta.tags.map(tag => {
          return tag.id;
        }) : [],
      currEditores = +this._meta.id !== 0 ?
        this._meta.editores.map(editor => {
          return editor.id;
        }) : [];
    const versionDisabled = !this._meta.isEditable;
    this.metaForm = this.fb.group({
      descripcionEN: [this._meta.htmlEN],
      descripcionES: [this._meta.htmlES],
      descripcionFR: [this._meta.htmlFR],
      tipoMeta: [currTipoMeta, [Validators.required]],
      cursos: [currCursos],
      areas: [currAreas],
      ambitos: [currAmbitos],
      tags: [currTags],
      profesores: [currEditores]
    });
  }

  public guardar() {
    const formVals = this.metaForm.value,
      cuentaCriterios = this._meta.criterios != null ? this._meta.criterios.length : 0;
    this.guardandoEvent.next(true);
    this._meta.categoria = {id: formVals.tipoMeta};
    this._meta.categoriaID = formVals.tipoMeta;
    this._meta.htmlEN = formVals.descripcionEN;
    this._meta.htmlES = formVals.descripcionES;
    this._meta.htmlFR = formVals.descripcionFR;
    this._meta.materias = formVals.areas.length > 0 ? formVals.areas.map(materia => {
      return {id: materia};
    }) : [];
    this._meta.cursos = formVals.cursos.length > 0 ? formVals.cursos.map(curso => {
      return {id: curso};
    }) : [];
    this._meta.ambitos = formVals.ambitos.length > 0 ? formVals.ambitos.map(ambito => {
      return {id: ambito};
    }) : [];
    this._meta.tags = formVals.tags.length > 0 ? formVals.tags.map(tag => {
      return {id: tag};
    }) : [];
    this._meta.editores = formVals.profesores.length > 0 ? formVals.profesores.map(editor => {
      return {id: editor};
    }) : [];
    if (+this._meta.id !== 0) {
      this.estudioService.actualizarMeta(this._meta).subscribe(resp => {
        this.deleteImageDirectives.forEach(item => item.reset());
        resp['cuentaCriterios'] = cuentaCriterios;
        this.estudioService.actualizarElemento('meta', resp);
        this.unidadEtapasService.actualizarLista('metas', resp);
        this.actualizar.emit(resp);
        if (this.unidadId) {
          this.estudioService.actualizarVersionMetaUnidad(this.unidadId, resp.id, resp.versionId).subscribe(
            res => {
              this.cancelar();
            },
            err => {
              this.guardandoEvent.next(false);
              this.customAlertService.setCustomMessage({
                tipo: 'error',
                texto: `No ha sido posible actualizar la versión de la meta. <br> Código de error: ${err.statusText}`
              });
            });
        } else {
          this.cancelar();
        }
      }, err => {
        this.guardandoEvent.next(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
        });
      });
    } else {
      this.estudioService.crearMeta(this._meta).subscribe(resp => {
        this.deleteImageDirectives.forEach(item => item.reset());
        const nuevaMeta = new Meta(resp);
        this.estudioService.actualizarLista(nuevaMeta, 'meta');
        this.actualizar.emit(nuevaMeta);
        if (this.unidadId) {
          this.estudioService.actualizarVersionMetaUnidad(this.unidadId, resp.id, resp.versionId).subscribe(
            res => {
              this.cancelar();
            },
            err => {
              this.guardandoEvent.next(false);
              this.customAlertService.setCustomMessage({
                tipo: 'error',
                texto: `No ha sido posible actualizar la versión de la meta. <br> Código de error: ${err.statusText}`
              });
            }
          );
        } else {
          this.cancelar();
        }
      }, err => {
        this.guardandoEvent.next(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
        });
      });
    }
  }

  public cancelar() {
    this.modalService.cerrarModal();
    this.cerrarDialog.emit();
  }

  setPristine(evt, criterio) {
    const notPristinableKeys = [9];
    if (notPristinableKeys.findIndex(key => evt === key) === -1) {
      criterio['isPristine'] = false;
    }
  }

  agregarCriterio(idMeta) {
    const model = {idOrigen: idMeta};
    this.estudioService.agregarCriterio(model).subscribe(res => {
      const nuevoCriterio: Criterio = this.estudioService.extractData(res);
      nuevoCriterio.idiomas.push({idioma: this.displayLang.toLowerCase(), nombre: '', criterioId: +nuevoCriterio.id});
      nuevoCriterio.niveles.forEach(element => {
        element.criterios.forEach(criterio => {
          criterio.idiomas.push({idioma: this.displayLang.toLowerCase(), nombre: '', criterioId: +criterio.id});
        });
      });
      this._meta.criterios.push(nuevoCriterio);
      this.snackBar.open('Criterio creado.', null, {duration: 2500});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible crear el criterio. <br> ${err.error} Código de error: ${err.statusText}`
      });
    });
  }

  agregarNivelCriterio(criterio) {
    const model = {idOrigen: criterio.id};
    this.estudioService.agregarNivelCriterio(model).subscribe(res => {
      const nuevoNivel: NivelCriterio = this.estudioService.extractData(res);
      nuevoNivel.criterios.forEach(indicador => {
        indicador.idiomas.push({idioma: this.displayLang.toLowerCase(), nombre: '', criterioId: +indicador.id});
      });
      criterio.niveles.push(nuevoNivel);
      this.snackBar.open('Nuevo nivel creado para el criterio.', null, {duration: 2500});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible crear el nivel para criterio. <br> ${err.error} Código de error: ${err.statusText}`
      });
    });
  }

  guardarCriterio(criterio, displayLang) {
    criterio.idioma = displayLang.toLowerCase();
    if (typeof criterio.isPristine !== 'undefined' && !criterio.isPristine) {
      this.estudioService.actualizarCriterio(criterio).subscribe((res) => {
        criterio.isPristine = true;
        criterio.idiomas.forEach(element => {
          if (displayLang.toLowerCase() !== element.idioma) {
            const idioma = res.idiomas.find(item => item.idioma === element.idioma);
            if (idioma) {
              element.nombre = idioma.nombre;
            }
          }
        });
        this.snackBar.open('Criterio actualizado.', null, {duration: 2500});
      }, err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la meta. <br> ${err.error} Código de error: ${err.statusText}`
        });
      });
    }
  }

  eliminarNivelCriterio(criterioID, nivelID) {
    this.estudioService.eliminarNivelCriterio(criterioID, nivelID).subscribe(() => {
      const indice = this._meta.criterios.findIndex(el => +el.id === +criterioID);
      if (indice > -1) {
        if (+nivelID === 0) {
          this._meta.criterios.splice(indice, 1);
        } else {
          const indiceNivel = this._meta.criterios[indice].niveles.findIndex(nivel => +nivel.id === +nivelID);
          if (indiceNivel > -1) {
            this._meta.criterios[indice].niveles.splice(indiceNivel, 1);
          }
        }
      }
      this.snackBar.open(`${+nivelID === 0 ? 'Criterio' : 'Nivel'} eliminado.`, null, {duration: 2500});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible eliminar el ${+nivelID === 0 ? 'criterio' : 'nivel'}.
            <br> ${err.error} Código de error: ${err.statusText}`
      });
    });
  }

  ordenarCriterios(event) {
    const arrIds = [];
    for (let i = 0; i < event.to.children.length; i++) {
      arrIds.push(event.to.children[i].dataset.criterioId.toString());
    }
    const strIds = arrIds.toString();
    this.unidadEtapasService.ordenarCriterios(strIds).subscribe(() => {
      this.snackBar.open(
        `Los criterios se han ordenado satisfactoriamente.`,
        null,
        {duration: 2250});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible ordenar los criterios. <br> Código de error: ${err.statusText}`
      });
    });
  }

  cambiarVersion(version) {
    const nuevaVersionIndex = this._meta.versiones.findIndex(item => item.majorVersion === 'Nueva versión');
    if (nuevaVersionIndex > -1) {
      this._meta.versiones.splice(nuevaVersionIndex, 1);
    }
    this._meta.versionId = version.id;
    this._meta.htmlEN = version.descEN;
    this._meta.htmlES = version.descES;
    this._meta.htmlFR = version.descFR;
    this._meta.txtEN = version.txtDescEN;
    this._meta.txtES = version.txtDescES;
    this._meta.txtFR = version.txtDescFR;
    const versionActualObj = this._meta.versiones.find(item => item.id === this._meta.versionId);
    if (versionActualObj) {
      this.versionActual = versionActualObj.majorVersion + '.' + versionActualObj.minorVersion;
    } else {
      this.versionActual = 'err';
    }
  }

  nuevaVersion() {
    this._meta.versionId = 0;
    this.versionActual = 'Nueva versión';
    this._meta.versiones.push({
      id: 0,
      majorVersion: '-1'
    });
    this.versionForm.setValue(0);
  }

  changeIdiomaDisplay(idiomaParam: string) {
    // Esto no me gusta pero toca hacer reestructuración de este componente para hacerlo de la manera correcta.
    this._meta.criterios.forEach(criterio => {
      if (criterio.idiomas.findIndex(item => item.idioma === idiomaParam.toLowerCase()) === -1) {
        criterio.idiomas.push({idioma: idiomaParam.toLowerCase(), criterioId: +criterio.id, nombre: ''});
      }
      criterio.niveles.forEach(nivel => {
        nivel.criterios.forEach(indicador => {
          if (indicador.idiomas.findIndex(item => item.idioma === idiomaParam.toLowerCase()) === -1) {
            indicador.idiomas.push({idioma: idiomaParam.toLowerCase(), criterioId: +indicador.id, nombre: ''});
          }
        });
      });
    });
    this.displayLang = idiomaParam;
  }

  ngOnDestroy() {
    this._meta = null;
  }
}
